import React from 'react';

const Footer = () => {
  return (
    <footer className="page-footer text-center mt-8" style={{ fontSize: '0.85rem', color: '#666' }}>
      <p>
        <span role="img" aria-label="globe">🌐</span> Mind Mesch by <strong>Samirac Partners, LLC</strong>
        &nbsp;|&nbsp;
        <a href="https://daisypal.com" target="_blank" rel="noopener noreferrer">See dAIsy in Action</a>
      </p>
    </footer>
  );
};

export default Footer;
